import { BaseController } from '@shared/basecontroller.controller';
import { SkrillWithdrawalForm } from './skrill-withdrawal-form.model';

class SkrillWithdrawalFormController extends BaseController {
  constructor(WithdrawalStore, FormService, AppService, $timeout) {
    'ngInject';

    super(AppService);

    this.WithdrawalStore = WithdrawalStore;
    this.FormService = FormService;
    this.$timeout = $timeout;
  }

  $onInit() {
    this.userCurrency$ = this.WithdrawalStore.getCurrency();
    this.session = this.getSession();

    this.form = new SkrillWithdrawalForm(this.details.customerProducts, this.details.paymentOptions);
    this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
    this.form.paymentOption = this.selectedPaymentOption.id;
    this.form.email = this.selectedPaymentOption.email;
    this.form.paymentOptionType = this.selectedPaymentOption.type;
    this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('withdrawal');
    this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('withdrawal');
    this.enableSidebar();
  }

  submit() {
    this.FormService.isSubmitting.next(true);

    let isChecked = this.form.subTransactions.filter(obj => {
      return obj.chargeFee === true;
    })

    if (!isChecked.length) {
      $('#invalidAction').modal('show');
      this.FormService.isSubmitting.next(false);

      return false;
    }

    this.WithdrawalStore.withdraw(this.form.toPayload())
      .then(() => this.handleSuccessfulSubmission())
      .catch((errors) => {
        this.form.error.setFormErrors(errors);
        this.FormService.isSubmitting.next(false);
      })
    ;
  }

  handleSuccessfulSubmission() {
    this.FormService.isSubmitting.next(false);
    this.form.clearError();
    this.form.props.readOnly = true;
    this.onSuccessfulSubmission({form: this.form, viewDetails: this.paymentOptionsViewDetails});
  }

  resetForm() {
    this.form.reset();
  }

  removeSubTransaction(subTransaction, index) {
    this.form.removeSubTransaction(subTransaction, index);
  }

  formatAmount(subTransaction) {
    return subTransaction.amount = parseFloat(subTransaction.amount);
  }

  enableSidebar() {
    this.$timeout(() => {
      $(".gateway-sidebar-wrap .fa-receipt").click(function(e){
        e.preventDefault();
        $(".gateway-sidebar-wrap").toggleClass('active');
      });
    }, 500);
  }

  get displayDeleteButton() {
    return this.form.subTransactions.length > 1;
  }
}

export default SkrillWithdrawalFormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/component/form/skrill/skrill-withdrawal-form.controller.js